import { render, staticRenderFns } from "./CartNotice.vue?vue&type=template&id=40a75468&scoped=true&"
import script from "./CartNotice.vue?vue&type=script&lang=js&"
export * from "./CartNotice.vue?vue&type=script&lang=js&"
import style0 from "./CartNotice.vue?vue&type=style&index=0&id=40a75468&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a75468",
  null
  
)

export default component.exports